import React, { useContext  } from 'react';
import { FormContext } from 'context/FormContext';

/**
 * RadioButton Element
 * @param {*} name
 * @param {*} value
 * @param {*} label
 * @param {*} sublabel
 * @param {*} small
 * @returns
 */
const RadioButton = (props) => {
    const { formValues, setFormValues } = useContext(FormContext);
    const value = props.value ? props.value : props.label;
    let isChecked = props.checked;

    if(value === formValues[props.name]){
        isChecked = true;
    }

    const onChange = (e) => {
        if(!props.disableContextAutoSave){
            setFormValues({ ...formValues, [e.target.name]: e.target.value });
        }

        if(props.onChange)
            props.onChange(e);
    }

    const getClasses = () => {
        const classes = ['RadioButton'];

        if(props.small){
            classes.push('small');
        }

        return classes.join(" ");
    }

    return (
        <div className={getClasses()}>
            <label>
                {/* <input type="radio" name={props.name} value={value} defaultChecked={isChecked} data-sublabel={props.sublabel} data-index={props.index} onChange={onChange} onClick={props.onClick} /> */}
                <input type="radio" name={props.name} value={value} checked={isChecked} data-sublabel={props.sublabel} data-index={props.index} onChange={onChange} onClick={props.onClick} />
                <div className="d-flex flex-column align-items-center justify-content-center">
                    { props.image && <img src={props.image} alt={props.label} /> }
                    <span className="label">{ props.label }</span>
                    { props.sublabel }
                </div>
            </label>
        </div>
    )
}

export default RadioButton;